import { useSref } from '@uirouter/react';

import { queryClient } from '@/react-tools/react-query';

import { Alert } from '@@/Alert';

export function NoAddonAccessView() {
  const { onClick, href } = useSref('portainer.logout');

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <div className="w-full max-w-md">
        <Alert color="warn" title="No add-ons available">
          Your team is restricted to add-ons, but none are available to you.
          Please contact your administrator.{' '}
          <a
            href={href}
            data-cy="noAddonAccess-logOut"
            onClick={(e) => {
              queryClient.clear();
              onClick(e);
            }}
          >
            Log out
          </a>
        </Alert>
      </div>
    </div>
  );
}
